import React, { useMemo } from 'react';
import { Button, ButtonClean, ConfirmModal, Loader, Subsection, useModalContext, } from '@fourthwall/components';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { routing } from '@utils/routing';
import { useSubscription } from '../../../../../../modules/Subscriptions';
import * as S from './CustomDomain.styled';
import { DomainTile } from './components/DomainTile/DomainTile';
import { useCustomDomain } from './hooks/useCustomDomain';
export const CustomDomain = () => {
    const { currentShop } = useCurrentShop();
    const { configurationStatus, connectionStatus, domainName, paidDomainName, isDnsConfigured, isConnecting, isDeleting, isRetrying, connectPaidDomain, deleteCustomDomain, retryCustomDomainConnection, } = useCustomDomain();
    const { open } = useModalContext();
    const { hasActiveProSubscription } = useSubscription();
    const paidDomainStatus = useMemo(() => {
        if (configurationStatus !== 'PAID_DOMAIN_ONLY') {
            return 'NOT_CONNECTED';
        }
        if (isDnsConfigured && connectionStatus === 'NOT_CONNECTED') {
            return 'CONNECTING';
        }
        return connectionStatus;
    }, [configurationStatus, connectionStatus, isDnsConfigured]);
    const handleDomainDelete = () => {
        open(ConfirmModal, {
            title: 'Are you sure you want to delete this domain?',
            text: (React.createElement(S.RemoveDomainTextContainer, null,
                "You'll still be able to access ",
                currentShop?.internalDomain,
                ".fourthwall.com")),
            confirmLabel: 'Delete',
            confirmAppearance: 'destructive',
            onConfirm: deleteCustomDomain,
        });
    };
    const renderContent = () => {
        if (configurationStatus === 'LOADING') {
            return (React.createElement(S.LoaderContainer, null,
                React.createElement(Loader, { size: "large" })));
        }
        if (configurationStatus === 'NONE') {
            return (React.createElement(S.ButtonContainer, null,
                React.createElement(Button, { appearance: "primary", label: "Connect domain", to: routing.settings.domain.create })));
        }
        return (React.createElement(React.Fragment, null,
            (configurationStatus === 'CUSTOM_DOMAIN_ONLY' || configurationStatus === 'BOTH') && (React.createElement(DomainTile, { domainName: domainName, status: connectionStatus, showViewDnsButton: connectionStatus === 'CONNECTED' ||
                    connectionStatus === 'PARTIALLY_CONNECTED' ||
                    connectionStatus === 'SYNCING_YOUR_DOMAIN', isRetrying: isRetrying, isConnecting: isConnecting, onDomainDelete: !isDeleting && connectionStatus !== 'REMOVAL_IN_PROGRESS'
                    ? handleDomainDelete
                    : undefined, onRetryConnection: retryCustomDomainConnection })),
            (configurationStatus === 'PAID_DOMAIN_ONLY' || configurationStatus === 'BOTH') && (React.createElement(DomainTile, { domainName: paidDomainName, status: paidDomainStatus, showSubscriptionBadge: hasActiveProSubscription, isRetrying: isRetrying, isConnecting: isConnecting, removeDomainLabel: "Disconnect domain", onDomainConnect: connectPaidDomain, onDomainDelete: configurationStatus === 'PAID_DOMAIN_ONLY' &&
                    paidDomainStatus !== 'REMOVAL_IN_PROGRESS' &&
                    paidDomainStatus !== 'NOT_CONNECTED' &&
                    !isDeleting
                    ? handleDomainDelete
                    : undefined })),
            configurationStatus === 'PAID_DOMAIN_ONLY' && (React.createElement(ButtonClean, { label: "Connect a custom domain", appearance: "secondary", to: routing.settings.domain.create }))));
    };
    return (React.createElement(Subsection, { title: "Custom domain" },
        React.createElement(S.Container, null,
            React.createElement("p", null,
                "Set a custom domain name for your site (i.e. mywebsite.com).",
                ' ',
                React.createElement(ButtonClean, { label: "Learn more", href: "https://help.fourthwall.com/hc/en-us/articles/13331283794587-How-do-I-use-a-custom-domain", target: "_blank" })),
            renderContent())));
};
